import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from 'react-table'

import * as Styles from '../humblebee/Sensor/style'
import axios from 'axios'
import Cookies from 'universal-cookie'
import LoadingOverlay from 'react-loading-overlay'
import BounceLoader from 'react-spinners/BounceLoader'
import { toast } from 'react-toastify'
import ToolkitProvider from 'react-bootstrap-table2-toolkit'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import GenericExportCSVModal from '../humblebee/shared/GenericExportCSVModal';
const cookies = new Cookies()

// const USERS_TABLE_COLUMNS = [
//   // {
//   //   Header: 'DP',
//   //   maxWidth: 60,
//   //   minWidth: 60,
//   //   width: 60,
//   //   Cell: ({ row }) => {
//   //     return row?.original?.userInfo?.profilePictureUrl ? (
//   //       <img
//   //         src={row?.original?.userInfo?.profilePictureUrl}
//   //         alt="Profile"
//   //         style={{ width: '50px', height: '50px', borderRadius: '50%' }}
//   //       />
//   //     ) : (
//   //       <img
//   //         src="https://media.istockphoto.com/id/1414774612/vector/bee-character.jpg?s=612x612&w=0&k=20&c=YBLQKadPoBfsSGGLBvkAt_3LqEytdHH3DVEE7dJUxqw="
//   //         alt="Profile"
//   //         style={{ width: '50px', height: '50px', borderRadius: '50%' }}
//   //       />
//   //     )
//   //   },
//   // },

//   {
//     Header: 'installment No.',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'installmentNo',
//   },
//   {
//     Header: 'Due Date',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'dueDate',
//   },
//   {
//     Header: 'principal Component',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'principalComponent',
//   },
//   {
//     Header: 'Interest Component',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'interestComponent',
//   },
//   {
//     Header: 'Total Emi',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'totalEMI',
//   },
//   {
//     Header: 'Balance',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'balance',
//   },
//   {
//     Header: 'Status',
//     maxWidth: 80,
//     minWidth: 80,
//     width: 80,
//     accessor: 'status',
//   },
//   // {
//   //   Header: "Actions",
//   // },
// ]

const loanScheduleData = [
    {
      installmentNo: 1,
      dueDate: "2024-04-15",
      principalComponent: 4000,
      interestComponent: 384,
      totalEMI: 4384,
      balance: 46000,
      status: "Paid",
    },
    {
      installmentNo: 2,
      dueDate: "2024-05-15",
      principalComponent: 4050,
      interestComponent: 334,
      totalEMI: 4384,
      balance: 41950,
      status: "Paid",
    },
    {
      installmentNo: 3,
      dueDate: "2024-06-15",
      principalComponent: 4100,
      interestComponent: 284,
      totalEMI: 4384,
      balance: 37850,
      status: "Pending",
    },
    {
      installmentNo: 4,
      dueDate: "2024-07-15",
      principalComponent: 4150,
      interestComponent: 234,
      totalEMI: 4384,
      balance: 33700,
      status: "Pending",
    },
    {
      installmentNo: 5,
      dueDate: "2024-08-15",
      principalComponent: 4200,
      interestComponent: 184,
      totalEMI: 4384,
      balance: 29500,
      status: "Pending",
    },
    {
      installmentNo: 6,
      dueDate: "2024-09-15",
      principalComponent: 4250,
      interestComponent: 134,
      totalEMI: 4384,
      balance: 25250,
      status: "Pending",
    },
    {
      installmentNo: 7,
      dueDate: "2024-10-15",
      principalComponent: 4300,
      interestComponent: 84,
      totalEMI: 4384,
      balance: 20950,
      status: "Pending",
    },
    {
      installmentNo: 8,
      dueDate: "2024-11-15",
      principalComponent: 4350,
      interestComponent: 34,
      totalEMI: 4384,
      balance: 16600,
      status: "Pending",
    },
    {
      installmentNo: 9,
      dueDate: "2024-12-15",
      principalComponent: 4384,
      interestComponent: 0,
      totalEMI: 4384,
      balance: 12216,
      status: "Pending",
    },
    {
      installmentNo: 10,
      dueDate: "2025-01-15",
      principalComponent: 4384,
      interestComponent: 0,
      totalEMI: 4384,
      balance: 7832,
      status: "Pending",
    },
    {
      installmentNo: 11,
      dueDate: "2025-02-15",
      principalComponent: 4384,
      interestComponent: 0,
      totalEMI: 4384,
      balance: 3448,
      status: "Pending",
    },
    {
      installmentNo: 12,
      dueDate: "2025-03-15",
      principalComponent: 3448,
      interestComponent: 0,
      totalEMI: 3448,
      balance: 0,
      status: "Pending",
    },
  ];
  
  const EXPORT_COLUMNS = [
    { label: 'Installment No.', key: 'installmentNo', path: 'installmentNo' },
    { label: 'Due Date', key: 'dueDate', path: 'dueDate' },
    { label: 'Principal Component', key: 'principalComponent', path: 'principalComponent' },
    { label: 'Interest Component', key: 'interestComponent', path: 'interestComponent' },
    { label: 'Total Emi', key: 'totalEMI', path: 'totalEMI' },
    { label: 'Balance', key: 'balance', path: 'balance' },
    { label: 'Status', key: 'status', path: 'status' },
    { label: 'Added on', key: 'createdAt', path: 'createdAt' },
    { label: 'User Count', key: 'userCount', path: 'userCount' }
  ];

  const columns = [
    { dataField: "installmentNo", text: "Installment No." },
    { dataField: "dueDate", text: "Due Date" },
    { dataField: "principalComponent", text: "Principal Component" },
    { dataField: "interestComponent", text: "Interest Component" },
    { dataField: "totalEMI", text: "Total Emi" },
    { dataField: "balance", text: "Balance" },
    { dataField: "status", text: "Status" },
    // {
    //   dataField: "type",
    //   text: "Type",
    //   formatter: (cell) => <p>{cell.join(",")}</p>,
    // },
    // { dataField: "createdAt", text: "Added on", formatter:formatCreatedAt },
    // { dataField: "userCount", text: "User Count",  formatter:formatUserCount},

  ];
  
export const LoanSchedule = () => {
  const { token } = '' //useSelector((state) => state.auth || {});
  const currentToken = cookies.get('access_token')

  const [openModal, setOpenModal] = useState(false)
  const [showExportModal, setShowExportModal] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Number of records per page
  const [totalRecords, setTotalRecords] = useState(0); // Total records from API

  const fetchData = async () => {
    try {
        setLoading(true)
     setData(loanScheduleData)
     setTotalRecords(loanScheduleData.length)
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
   fetchData()
  }, []);

 
  const paginationOptions = {
    totalSize: totalRecords, // Set total records count
    sizePerPage: pageSize,
    sizePerPageList: [10, 25, 50], // Page size options
    page: currentPage,
    onPageChange: (page) => setCurrentPage(page), // Change page
    onSizePerPageChange: (size) => {
      setPageSize(size);
      setCurrentPage(1); // Reset to first page when changing page size
    }
  };

  // if (loading) return <div>Loading...</div>;
  // if (error) return <div>Error fetching data: {error.message}</div>;

  return (
    <div className="">
    <LoadingOverlay
      active={loading || false}
      spinner={<BounceLoader />}
    >
      <Styles.UserBox3>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h3 style={{
          fontSize:20,
          fontWeight:'600',
        }}>Loan Emi Schedule</h3>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => setShowExportModal(true)}
        >
          <i className="fa fa-download mr-2" aria-hidden="true"></i>
          Export CSV
        </button>
      </div>
      <ToolkitProvider keyField="userCount" data={data} columns={columns} search>
          {(props) => (
            <>
              {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "10px 0 20px",
          }}
        >
        </div> */}

              <BootstrapTable {...props.baseProps} pagination={paginationFactory(paginationOptions)} hover bootstrap4 />
            </>
          )}
        </ToolkitProvider>
        <GenericExportCSVModal
          show={showExportModal}
          onHide={() => setShowExportModal(false)}
          data={data}
          columns={EXPORT_COLUMNS}
          title="Export Loan Schedule to CSV"
          filenamePrefix="loan_schedule_export"
        />
      </Styles.UserBox3>
    </LoadingOverlay>
    </div>

  )
}

